package com.xtream.ui.tv.presentation.account

import androidx.compose.foundation.background
import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Help
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.outlined.Key
import androidx.compose.material.icons.rounded.Warning
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.composeapp.platform.getDeviceInfo
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.presentation.widget.ContactInfoDialog
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.account_text
import com.xtream.sharedResources.resources.activate
import com.xtream.sharedResources.resources.activation_code
import com.xtream.sharedResources.resources.activation_code_length_error
import com.xtream.sharedResources.resources.code_validation_error
import com.xtream.sharedResources.resources.created_date_text
import com.xtream.sharedResources.resources.device_id
import com.xtream.sharedResources.resources.enter_activation_code
import com.xtream.sharedResources.resources.exp_date_text
import com.xtream.sharedResources.resources.pro_message
import com.xtream.sharedResources.resources.support_contact
import com.xtream.sharedResources.resources.trial_warning
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.data_kmp.dto.BaseAccount
import com.xtream.data_kmp.dto.UserInfo
import com.xtream.data_kmp.util.extension.stringDateFromTimeStamp
import com.xtream.ui.ui.widget.TvButton
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


@Composable
fun ComposeAccountTvScreen(
    userViewModel: UserViewModel = koinViewModel()
) {
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )
    val appSettingsViewModel: AppSettingsViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )


    val loggedInUserFlow by userViewModel.loggedInUserFlow.collectAsState(initial = null)
    val userInfoState by userViewModel.userInfoState.collectAsStateWithLifecycle()

    val showDialog = userInfoState is ApiSealed.Loading


    /*val bottomIme= WindowInsets.ime.getBottom(LocalDensity.current)
    val imeVisible = bottomIme > 0
    val imeBottomPadding by remember {
        derivedStateOf {
            if (imeVisible)
                bottomIme.dp
            else
                0.dp
        }
    }*/
    //LoadingDialog(showDialog)
    if(showDialog)
        Text("ShowLoadingDialog")

    LazyColumn (
        //verticalAlignment = Alignment.CenterVertically,
        contentPadding = PaddingValues(bottom = 16.dp)
    ){
        stickyHeader {
            @OptIn(ExperimentalMaterial3Api::class)
            TopAppBar(
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = MaterialTheme.colorScheme.background,
                    titleContentColor = MaterialTheme.colorScheme.onBackground
                ),
                title = {

                    Text(
                        text = stringResource(Res.string.account_text),
                        style = MaterialTheme.typography.headlineSmall,
                        modifier = Modifier
                            .padding(bottom = 16.dp)
                            .fillMaxWidth()
                    )
                })
        }
        item {
            TrialLayout(
                modifier = Modifier
                    .padding(top = 24.dp, start = 16.dp, end = 16.dp, bottom = 16.dp)
                    .wrapContentHeight(),
                isTrial = loggedInUserFlow?.userInfo?.isTrial,
                userViewModel=userViewModel,
                rootNavViewModel = rootNavViewModel,
                appSettingsViewModel = appSettingsViewModel,
                userInfoState = userInfoState
            )
        }
        item {
            AccountInfo(Modifier
                .padding(top = 16.dp, start = 16.dp, end = 16.dp, bottom = 16.dp)

                .wrapContentHeight(),
                userInfo = loggedInUserFlow?.userInfo
            )
        }
    }
}






@Composable
fun TrialAccountCard(
    containerColor:Color = MaterialTheme.colorScheme.primary.copy(alpha = .07f),
    contentColor:Color = MaterialTheme.colorScheme.primary,
    icon: ImageVector= Icons.Rounded.Warning,
    title: String="",
    contentDescription: String = "Trial"
) {

    var showDialog by remember { mutableStateOf(false) }
    ContactInfoDialog(
        showDialog,
        onDismiss = {
            showDialog = false
        }

    )
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .wrapContentHeight()

            .heightIn(min = 90.dp),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(
            containerColor = containerColor
        ),
        elevation = CardDefaults.cardElevation(0.dp)
    ) {

        Spacer( modifier = Modifier.height(16.dp))
        Icon(
            imageVector = icon,
            contentDescription = contentDescription,
            tint = contentColor,
            modifier = Modifier

                .size(48.dp)
                .align(Alignment.CenterHorizontally)



        )

        Text(
            modifier = Modifier
                .fillMaxWidth()
                .padding(12.dp),

            text = title,
            textAlign = TextAlign.Center,
            style = MaterialTheme.typography.bodyLarge.copy(
                fontWeight = FontWeight.Medium,
                shadow = Shadow(
                    color = Color.Black.copy(alpha = 0.5f), // shadow color
                    offset = Offset(1f, 1f),               // x and y offset
                    blurRadius = 1f                         // blur
                ),
                color = contentColor // Rich brown color
            )
        )


        TvButton(
            modifier = Modifier

                .align(Alignment.CenterHorizontally)
                .fillMaxWidth(.7f)
                .height(48.dp)
            ,
            title = stringResource(Res.string.support_contact),
            leadingIcon =  rememberVectorPainter(Icons.AutoMirrored.Filled.Help),


            ) {
            showDialog = true

        }
        Spacer(Modifier. height( 24.dp))
    }
}



@Composable
fun TrialLayout(
    modifier: Modifier = Modifier,
    isTrial: String? = null,
    userViewModel: UserViewModel,
    appSettingsViewModel: AppSettingsViewModel,
    rootNavViewModel: RootNavViewModel,
    userInfoState: ApiSealed<BaseAccount>,




    ) {

    var activationText by rememberSaveable { mutableStateOf("") }

    val buttonFocusRequests = remember { FocusRequester() }

    val scope = rememberCoroutineScope()
    val deviceInfo=getDeviceInfo()
    isTrial?.let {

        Column (
            modifier = modifier,
            verticalArrangement = Arrangement.spacedBy(12.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {



            val isPro= it == "0"
            val isTrial = it == "1"
            if(isPro){
                TrialAccountCard(
                    icon = Icons.Filled.CheckCircle,
                    title = stringResource(Res.string.pro_message),
                    contentDescription = stringResource(Res.string.pro_message),
                    containerColor = Color.Green.copy(alpha = .1f),
                    contentColor = Color.Green
                )

            }
            else if (isTrial) {

                var inputHasError by remember { mutableStateOf(false) }
                OutlinedTextField(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(10.dp),
                    value = activationText,
                    onValueChange = {
                        inputHasError = it.isEmpty()
                        activationText = it.filter { it.isDigit() }.take(13)
                    },
                    label = {
                        Text(stringResource(Res.string.enter_activation_code))
                    },
                    isError = inputHasError,
                    supportingText = {
                        if (inputHasError) {
                            Text(
                                if (activationText.length < 6)
                                    stringResource(Res.string.activation_code_length_error)
                                else if (userInfoState is ApiSealed.Error) {

                                    (userInfoState as? ApiSealed.Error?)?.message
                                        ?: ""
                                } else
                                    stringResource(Res.string.code_validation_error)
                            )
                        }
                    },
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Number,

                        imeAction = ImeAction.Done,

                        ),
                    keyboardActions = KeyboardActions(
                        onDone = {
                            inputHasError =
                                activationText.isEmpty() || activationText.length < 6
                            if (!inputHasError) {
                                buttonFocusRequests.requestFocus()
                            }

                        }
                    ),

                    textStyle = MaterialTheme.typography.titleMedium,
                )

                TvButton(
                    modifier = Modifier.focusRequester(buttonFocusRequests)
                        .fillMaxWidth(.7f)
                        .height(48.dp)
                    ,
                    title = stringResource(Res.string.activate),
                    leadingIcon = rememberVectorPainter(Icons.Outlined.Key),
                    onClick = {
                        inputHasError =
                            activationText.isEmpty() || activationText.length < 6
                        if (!inputHasError)
                            scope.launch {
                                userViewModel.checkByActivationCode(
                                    activationCodeVal = activationText,
                                    deviceInfo =deviceInfo,
                                    onSuccess = {
                                        userViewModel.resetLastDataUpdateTime() {
                                            appSettingsViewModel.setSkipAccountRefresh(true) {
                                                rootNavViewModel.backStack.clear()
                                                rootNavViewModel.backStack.add(
                                                    Screen.Loading(
                                                        forceRefreshData = true,
                                                        skipUserRefresh = true
                                                    )
                                                )
                                            }
                                        }
                                    },
                                    onError = {
                                        inputHasError = true
                                    }
                                )

                            }

                    }
                )
                Spacer( modifier = Modifier.height(16.dp))

                TrialAccountCard(
                    title = stringResource(Res.string.trial_warning)
                )


            }

        }
    }
}
@Composable
fun AccountInfo(
    modifier: Modifier= Modifier,
    userInfo: UserInfo?


){
    val  deviceInfo = getDeviceInfo()
    Column(
        modifier =    modifier

            .background(MaterialTheme.colorScheme.background)
    ) {


        userInfo?.let { info ->
            Column (
                verticalArrangement = Arrangement.spacedBy(12.dp),
                modifier = Modifier.fillMaxSize(),
            ) {
                InfoCard(
                    title = stringResource(
                        if (info.activationCode != null)
                            Res.string.activation_code
                        else
                            Res.string.account_text
                    ),
                    description = info.activationCode ?: info.username
                )


                InfoCard(
                    title = stringResource(Res.string.created_date_text),
                    description = info.createdAt?.stringDateFromTimeStamp().orEmpty()
                )
                InfoCard(
                    title = stringResource(Res.string.exp_date_text),
                    description = info.expDate?.stringDateFromTimeStamp().orEmpty()
                )
                InfoCard(
                    title = stringResource(Res.string.device_id),
                    description = deviceInfo.deviceId?:""
                )

            }
        }

    }
}



























@Composable
fun ComposeAccountTvScreen(
    userViewModel:  UserViewModel = koinViewModel(),
    rowsContentPadding: PaddingValues,
    contentPadding: PaddingValues
) {
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel:  RootNavViewModel =
        koinViewModel(
            viewModelStoreOwner = viewModelStoreOwner
        )
    val appSettingsViewModel:  AppSettingsViewModel =
        koinViewModel(
            viewModelStoreOwner = viewModelStoreOwner
        )


    val loggedInUserFlow by userViewModel.loggedInUserFlow.collectAsState(initial = null)
    val userInfoState by userViewModel.userInfoState.collectAsStateWithLifecycle()

    val showDialog = userInfoState is  ApiSealed.Loading


    /*val bottomIme= WindowInsets.ime.getBottom(LocalDensity.current)
    val imeVisible = bottomIme > 0
    val imeBottomPadding by remember {
        derivedStateOf {
            if (imeVisible)
                bottomIme.dp
            else
                0.dp
        }
    }*/
    if(showDialog)
        Text("Loading")
    //LoadingDialog(showDialog)
    Row(
        //verticalAlignment = Alignment.CenterVertically,
    ){
        TrialLayout(
            contentPadding = rowsContentPadding,

            modifier = Modifier
                .padding(top = contentPadding.calculateTopPadding(), bottom = 16.dp)

                .weight(1f),
            isTrial = loggedInUserFlow?.userInfo?.isTrial,
            userViewModel=userViewModel,
            rootNavViewModel = rootNavViewModel,
            appSettingsViewModel = appSettingsViewModel,
            userInfoState = userInfoState
        )
        AccountInfo(Modifier
            .weight(1f)
            .padding(
                top = contentPadding.calculateTopPadding(),
                start = 16.dp,
                end = 16.dp,
                bottom = 16.dp
            )

            .fillMaxSize(),
            userInfo = loggedInUserFlow?.userInfo
        )
    }
}
@Composable
fun InfoCard(title: String, description: String) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .defaultMinSize(minHeight = 64.dp),
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        elevation = CardDefaults.cardElevation(defaultElevation = 1.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Text(
                text = title,
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary
            )
            Spacer(modifier = Modifier.height(4.dp))
            Text(
                text = description,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurface
            )
        }
    }
}




@Composable
fun TrialLayout(
    modifier: Modifier = Modifier,
    isTrial: String? = null,
    userViewModel: UserViewModel,
    appSettingsViewModel: AppSettingsViewModel,
    rootNavViewModel: RootNavViewModel,
    userInfoState: ApiSealed<BaseAccount>,
    contentPadding :  PaddingValues = PaddingValues(0.dp),



    ) {

    val tabBarFocusRequester = remember { FocusRequester() }

    isTrial?.let {

        LazyColumn (
            modifier = modifier
                .focusRestorer(tabBarFocusRequester)
                .focusGroup(),
            verticalArrangement = Arrangement.spacedBy(12.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            contentPadding = contentPadding
        ) {
            item {
                Text(
                    text = stringResource(Res.string.account_text),
                    style = MaterialTheme.typography.headlineSmall,
                    modifier = Modifier
                        .padding(bottom = 16.dp)
                        .fillMaxWidth()
                )
            }

            val isPro= it == "0"
            val isTrial = it == "1"
            if(isPro){
                item{

                    TrialAccountCard(
                        icon = Icons.Filled.CheckCircle,
                        title = stringResource(Res.string.pro_message),
                        contentDescription = stringResource(Res.string.pro_message),
                        containerColor = Color.Green.copy(alpha = .1f),
                        contentColor = Color.Green
                    )
                }
            }
            else if (isTrial) {
                item{

                    /*val pagerState = rememberPagerState() { 2 }
                    val scope = rememberCoroutineScope()
                    AccountTabRow(modifier=Modifier.focusRequester(tabBarFocusRequester), onTabSelected = { index -> scope.launch { pagerState.animateScrollToPage(index) }})
                    HorizontalPager(
                        modifier = Modifier ,
                       state= pagerState

                    ) { page ->
                        when (page) {
                            0 -> ActivationColumn(userInfoState = userInfoState, userViewModel=userViewModel)
                            1 -> UserPasswordColumn(userInfoState = userInfoState, userViewModel=userViewModel)
                        }
                    }*/

                    ActivationColumn(userInfoState = userInfoState,
                        rootNavViewModel = rootNavViewModel,
                        appSettingsViewModel = appSettingsViewModel,


                        userViewModel=userViewModel)
                    Spacer( modifier = Modifier.height(16.dp))

                    TrialAccountCard(
                        title = stringResource(Res.string.trial_warning)
                    )

                }
            }

        }
    }
}







@Composable
fun ActivationColumn(
    userInfoState: ApiSealed<BaseAccount>,
    appSettingsViewModel: AppSettingsViewModel,
    rootNavViewModel: RootNavViewModel,
                     userViewModel: UserViewModel) {

    var activationText by rememberSaveable { mutableStateOf("") }

    val buttonFocusRequests = remember { FocusRequester() }

    val scope = rememberCoroutineScope()
    var inputHasError by remember { mutableStateOf(false) }
    val deviceInfo=getDeviceInfo()
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,

        ) {
        OutlinedTextField(
            modifier = Modifier
                .fillMaxWidth()
                .padding(10.dp),
            value = activationText,
            onValueChange = {
                inputHasError = it.isEmpty()
                activationText = it.filter { it.isDigit() }.take(13)
            },
            label = {
                Text(stringResource(Res.string.enter_activation_code))
            },
            isError = inputHasError,
            supportingText = {
                if (inputHasError) {
                    Text(
                        if (activationText.length < 6)
                            stringResource(Res.string.activation_code_length_error)
                        else if (userInfoState is ApiSealed.Error) {

                            (userInfoState as? ApiSealed.Error?)?.message
                                ?: ""
                        } else
                            stringResource(Res.string.code_validation_error)
                    )
                }
            },
            keyboardOptions = KeyboardOptions(
                keyboardType = KeyboardType.Number,

                imeAction = ImeAction.Done,

                ),
            keyboardActions = KeyboardActions(
                onDone = {
                    inputHasError =
                        activationText.isEmpty() || activationText.length < 6
                    if (!inputHasError) {
                        buttonFocusRequests.requestFocus()
                    }

                }
            ),

            textStyle = MaterialTheme.typography.titleMedium,
        )

        TvButton(
            modifier = Modifier
                .focusRequester(buttonFocusRequests)
                .fillMaxWidth(.7f)
                .height(48.dp)
                ,
            title = stringResource(Res.string.activate),
            leadingIcon = rememberVectorPainter(Icons.Outlined.Key),
            onClick = {
                inputHasError =
                    activationText.isEmpty() || activationText.length < 6
                if (!inputHasError)
                    scope.launch {
                        userViewModel.checkByActivationCode(
                            activationCodeVal = activationText,
                            deviceInfo =deviceInfo,
                            onSuccess = {
                                userViewModel.resetLastDataUpdateTime() {
                                    appSettingsViewModel.setSkipAccountRefresh(true) {
                                        rootNavViewModel.backStack.clear()
                                        rootNavViewModel.backStack.add(
                                            Screen.Loading(
                                                forceRefreshData = true,
                                                skipUserRefresh = true
                                            )
                                        )
                                    }                                }

                            },
                            onError = {
                                inputHasError = true
                            }
                        )

                    }

            }
        )
    }
}









